import graphql__80ac7873fe772c2ac9c2 from "./__generated__/MapElementTooltip_tooltip.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import { Tooltip } from "react-leaflet";

import { hasHtmlContent, cleanHtml } from "../Utils/htmlStringUtils";

const MapElementTooltip = props => {
  if (!props.tooltip) return null;

  const { content } = props.tooltip;

  if (!content || !hasHtmlContent(content)) return null;

  return (
    <Tooltip sticky={true}>
      <div dangerouslySetInnerHTML={{ __html: cleanHtml(content) }} />
    </Tooltip>
  );
};

export default createFragmentContainer(MapElementTooltip, {
  tooltip: graphql__80ac7873fe772c2ac9c2
});
